import { helper } from 'utils';
const { isDevelopment, isDebugMode } = helper;

const QA = {
  redirector: 'https://bg.onelink.me/2pGm/oj8gshg2',
  fileHost: 'https://d2zqqna63nq7gm.cloudfront.net/',
  payment: {
    env: 'int',
    merchantSiteId: '237979',
    merchantId: '7626846318643392526',
    sdk: 'https://cdn.safecharge.com/safecharge_resources/v1/checkout/checkout.js',
  },
  api: {
    login: 'https://api-es-qa1.bbum-bg.com/login',
    store: 'https://api-es-qa1.bbum-bg.com/ims',
    purchaseInvoice: 'https://api-es-qa1.bbum-bg.com/createPurchaseInvoice',
    invoiceStatus: 'https://api-es-qa1.bbum-bg.com/getPurchaseInvoice',
    claimDynamicBonus: 'https://api-es-qa1.bbum-bg.com/claimDynamicBonus',
  },
  fb: {
    appId: '1383052272207750',
    redirectUri: isDevelopment ? 'http://localhost:3000/login' : 'https://estore-qa1.bbum-bg.com/login',
    sdk: 'https://connect.facebook.net/en_US/sdk/debug.js',
  },
  info: {
    privacyPolicy: 'https://www.bbumgames.com/privacy-policy',
    termsConditions: 'https://www.bbumgames.com/terms-of-service',
    contactSupport: 'https://fb2.bbumgames.com/support_m.html',
    socials: {
      facebook: 'https://www.facebook.com/Backgammon.LOTB',
      instagram: 'https://www.instagram.com/lordoftheboard_official',
      x: 'https://x.com/Lordoftheboard3',
    },
  },
};

const PROD = {
  redirector: 'https://bg.onelink.me/2pGm/oj8gshg2',
  fileHost: 'https://d27arutwwr0bum.cloudfront.net/',
  payment: {
    env: 'prod',
    merchantSiteId: '247546',
    merchantId: '7991994546705616406',
    sdk: 'https://cdn.safecharge.com/safecharge_resources/v1/checkout/checkout.js',
  },
  api: {
    login: 'https://api-es.bbumgames.com/login',
    store: 'https://api-es.bbumgames.com/ims',
    purchaseInvoice: 'https://api-es.bbumgames.com/createPurchaseInvoice',
    invoiceStatus: 'https://api-es.bbumgames.com/getPurchaseInvoice',
    claimDynamicBonus: 'https://api-es.bbumgames.com/claimDynamicBonus',
  },
  fb: {
    appId: '544130455745554',
    redirectUri: 'https://estore.bbumgames.com/login',
    sdk: 'https://connect.facebook.net/en_US/sdk.js',
  },
  info: {
    privacyPolicy: 'https://www.bbumgames.com/privacy-policy',
    termsConditions: 'https://www.bbumgames.com/terms-of-service',
    contactSupport: 'https://fb2.bbumgames.com/support_m.html',
    socials: {
      facebook: 'https://www.facebook.com/Backgammon.LOTB',
      instagram: 'https://www.instagram.com/lordoftheboard_official',
      x: 'https://x.com/Lordoftheboard3',
    },
  },
};

export default isDebugMode ? QA : PROD;
